var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1,18.9c-5.7,0-8.2-2.8-10.6-5.6L0.3,12l0.6-0.7c0.3-0.3,0.5-0.6,0.8-0.9C4,7.8,6.3,5.1,11.9,5.1 c5.7,0,8.2,2.8,10.6,5.6l1.2,1.3l-0.6,0.7c-0.3,0.3-0.5,0.6-0.8,0.9C20,16.2,17.7,18.9,12.1,18.9z M3,12L3,12 c2.3,2.6,4.3,4.9,9.1,4.9c4.6,0,6.5-2.1,8.6-4.6c0.1-0.1,0.2-0.2,0.2-0.3l0,0c-2.3-2.6-4.3-4.9-9.1-4.9c-4.6,0-6.5,2.1-8.6,4.6 C3.2,11.8,3.1,11.9,3,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.db9d32a61af539b3f57ad4cc4580eab9.svg";
export { ForwardRef as ReactComponent };